require("./navigation.js");
require("./slides.js");
require("./search.js");
require("./cookie.js");
